import testImage from '../assets/img/szkolenia.jpg'

import annaScislowskaImagePath from '../assets/img/contact/staff_anna_scislowska.png'
import jacekCiechanowskiImagePath from '../assets/img/contact/AU.png'
import karolinaMerdaImagePath from '../assets/img/contact/MP.png'

import HomepageCardClassroomIconPath from '../assets/icons/homepage/classroom.svg'
import HomepageCardSuccessIconPath from '../assets/icons/homepage/success.svg'
import HomepageCardWorkIconPath from '../assets/icons/homepage/work.svg'

import HomepageCvTemplate1ImagePath from '../assets/img/homepage/1.jpg'
import HomepageCvTemplate2ImagePath from '../assets/img/homepage/2.jpg'
import HomepageCvTemplate3ImagePath from '../assets/img/homepage/3.jpg'

import HomepageSquarePanel1IconPath from '../assets/icons/homepage/squarePanel1.svg'
import HomepageSquarePanel2IconPath from '../assets/icons/homepage/squarePanel2.svg'
import HomepageSquarePanel3IconPath from '../assets/icons/homepage/squarePanel3.svg'

import HomepageEmployersAmazonImagePath from '../assets/icons/homepage/employers/amazon.png'
import HomepageEmployersCeneoImagePath from '../assets/icons/homepage/employers/ceneo.png'
import HomepageEmployersHpImagePath from '../assets/icons/homepage/employers/hp.png'
import HomepageEmployersImpelImagePath from '../assets/icons/homepage/employers/impel.png'
import HomepageEmployersQatarImagePath from '../assets/icons/homepage/employers/qatar.png'
import HomepageEmployersVolvoImagePath from '../assets/icons/homepage/employers/volvo.png'

const translationsListPL = {
  ticketAdditionalInfo: 'Bilet imienny upoważnia do wstępu jednej osoby na targi. Bilet ważny jest tylko za okazaniem dowodu potwierdzającego tożsamość.',
  banners: {
    bannersList: [
      {
        buttonLabel: 'Dodaj do kalendarza',
        description: 'Wstęp całkowicie bezpłatny',
        link: 'https://calendar.google.com/event?action=TEMPLATE&tmeid=NG5oZ3ZtcmNsZTRiMG1qdXQwNzd0bmN0YWggNzJjcjZ0MnZjMzhjZDN1cmVzMms4aWw0dGNAZw&tmsrc=72cr6t2vc38cd3ures2k8il4tc%40group.calendar.google.com',
        title: 'Do zobaczenia na największych zachodniopomorskich Targach Pracy!'
      }
    ]
  },
  buttonSwitch: {
    itemsList: [
      {
        isActive: true,
        label: 'Wszystkie'
      },
      {
        isActive: false,
        label: 'Zapisane'
      }
    ]
  },
  buttons: {
    labels: {
      addNewButtonLabel: 'Dodaj kolejny'
    }
  },
  chooseColor: {
    labels: {
      buttonLabel: 'stwórz własny',
      headerLabel: 'Wybierz kolor przewodni twojego CV',
      subtitleLabel: 'Bądź wyjątkowy'
    }
  },
  chooseImage: {
    labels: {
      chooseImageInfo: 'Maksymalnie rozmiar zdjęcia to 320x320 (500kb)',
      chooseImageRemoveButtonLabel: 'Usuń',
      chooseImageSelectButtonLabel: 'Wybierz zdjęcie',
      imageLabel: 'Twoje zdjęcie'
    }
  },
  cities: {
    labels: {
      titleLabel: 'Wybierz miasto'
    },
    citiesList: [
      {
        _id: 0,
        label: 'Wrocław',
        isSelected: false
      }
    ]
  },
  companies: {
    labels: {
      employer: 'pracodawcĂłw',
      found: 'Znaleziono'
    }
  },
  controls: {
    labels: {
      buttonHide: 'Ukryj',
      buttonShowMore: 'Pokaż więcej'
    }
  },
  employerProfiles: {
    labels: {
      complianceLabel: 'zgodności',
      subtitleSimilarEmployersLabel: 'Podobni pracodawcy'
    }
  },
  errorsMessages: {
    userDataForm: {
      userAddressErrorMessage: 'Wpisz poprawny adres',
      userCityErrorMessage: 'Wpisz poprawne miasto',
      userCountryErrorMessage: 'Wpisz poprawny kraj',
      userDateOfBirthErrorMessage: 'Wpisz poprawną datę urodzenia ',
      userEmailErrorMessage: 'Wpisz poprawny adres e-mail',
      userNameErrorMessage: 'Wpisz poprawne imię',
      userNationalityErrorMessage: 'Wpisz poprawne obywatelsto',
      userPhoneErrorMessage: 'Wpisz poprawny numer telefonu',
      userPostCodeErrorMessage: 'Wpisz poprawny kod pocztowy',
      userSocialMediaDescriptionErrorMessage: 'Wpisz poprawny opis',
      userSocialMediaErrorMessage: 'Wpisz poprawny link',
      userSurnameErrorMessage: 'Wpisz poprawne nazwisko'
    },
    notSaved: 'Nastąpił problem z zapisywaniem. Spróbuj ponownie później. Jeżeli problem się ponawia skontaktuj się z nami.',
    validationError: 'Wprowadzono nie poprawne dane.',
    userExist: 'Użytkownik z takim emailem już istnieje.',
    userNotExist: 'Nieprawidłowy email lub hasło.'
  },
  events: {
    labels: {
      addressLabel: 'Adres',
      dateLabel: 'Data',
      nameAndSurnameLabel: 'Imię i nazwisko',
      placeLabel: 'Miejsce',
      positionLabel: 'Stanowisko',
      timeLabel: 'Godzina',
      titleLabel: 'Zapraszamy'
    },
    eventsList: [
      {
        eventAdditionalInfo: 'Bilet imienny upoważnia do wstępu jednej osoby na targi. Bilet ważny jest tylko za okazaniem dowodu potwierdzającego tożsamość.',
        eventAddress: 'Hala Stulecia, Wystawowa 1, Wrocław',
        eventDate: '20.05.2018',
        eventTimeEnd: '18:00',
        eventTimeStart: '10:00'
      }
    ]
  },
  faq: {
    labels: {
      faqPage: 'FAQ'
    },
    itemsList: [
      {
        title: '01. Co muszę zrobić, żeby wziąć udział w targach Career EXPO?',
        text: 'Wystarczy, że zarejestrujesz się za pośrednictwem naszej strony internetowej. Na Twoją skrzynkę mailową zostanie wysłany mail z linkiem aktywacyjnym, który upoważnia Cię do pobrania darmowego biletu wstępu. Bilet pobierz na swoje urządzenie mobilne lub wydrukuj i okaż po wejściu do hali, w której odbywają się targi. Zapraszamy! :)'
      },
      {
        title: '02. Czy udział w targach jest płatny?',
        text: 'Nie, udział w Career EXPO nic nie kosztuje. Możesz jednak wziąć trochę drobnych na kawę i ciasto, które będziesz mógł kupić na terenie hali, jak już zmęczysz się rozmowami z firmami :)'
      },
      {
        title: '03. Czy muszę drukować bilet?',
        text: 'Powinieneś - po pierwsze dlatego, że łatwiej będzie nam go zeskanować. Po drugie - na bilecie znajduje się okienko z Twoim imieniem i nazwiskiem, które na targach możesz wyciąć w specjalnym punkcie i włożyć do identyfikatora, który otrzymasz od nas bezpłatnie. Wówczas rekruterzy widzą od razu, z kim rozmawiają :) Jeśli nie uda Ci się wydrukować biletu, możesz go ściągnąć na swoje urządzenie mobilne. Po wejściu na halę, w której odbywają się targi, okaż nam go na wyświetlaczu.'
      },
      {
        title: '04. Czy na jeden bilet może wejść większa ilość osób? Jeśli przyjeżdżamy grupą, czy możemy wygenerować grupowy bilet?',
        text: 'Każda osoba, która chce wziąć udział w targach musi się zarejestrować. Bilet jest indywidualny i przypisany tylko jednej osobie.'
      },
      {
        title: '05. Co zrobić, jeśli nie mogę zarejestrować się online lub pobrać biletu?',
        text: 'Nic straconego, nie rezygnuj z uczestnictwa w targach! Po wejściu do hali, zgłoś się do stoiska rejestracji, a my pomożemy Ci dopełnić wszelkich formalności. Byłoby nam miło, gdybyś też opisał dokładnie problem i wysłał nam taki feedback za pomocą naszego fanpage na Facebooku: https://www.facebook.com/pl.careerEXPO'
      },
      {
        title: '06. Can I participate at the event, when I’m english speaking person?',
        text: 'Yes, you can! :) Most of our exhibitors speak english or other languages and they look for employees with language skills. Out staff also is english-speaking so you can ask us whatever you want to. So feel free to visit Career EXPO and find your perfect job!'
      },
      {
        title: '07. Jak zgłosić swój udział w Szybkiej Rekrutacji?',
        text: 'Aby umówić się na Szybką Rekrutację podczas targów, pamiętaj, żeby po zalogowaniu się na swój profil wypełnić CV. Dzięki temu nie będziesz musiał załączać już żadnych dodatkowych dokumentów, a Twoje dane, umiejętności i doświadczenie będzie widoczne dla pracodawcy, z którym chcesz się skontaktować. Następnie zapoznaj się z listą firm, które biorą udział w Szybkiej Rekrutacji wchodząc w odpowiednią zakładkę na swoim koncie i wybierz tę, do której chcesz aplikować. Twoja aplikacja zostanie wysłana bezpośrednio do rekruterów wybranej firmy, a jeśli jej weryfikacja przebiegnie pomyślnie, rekruterzy skontaktują się z Tobą w celu ustalenia godziny spotkania. Pamiętaj, żeby regularnie sprawdzać swoją skrzynkę e-mail! Po wejściu na teren targów, zgłoś się do stoiska firmy, z którą jesteś umówiony o danej godzinie. Nie spóźnij się! Powodzenia! :)'
      },
      {
        title: '08. Jak zapisać się na szkolenie/prelekcję?',
        text: 'Możesz to zrobić logując się na swoje konto, gdzie znajdziesz aktualną listę szkoleń lub prelekcji dla danego miasta. Zapisujesz się klikając przycisk “zapisz” obok wybranego szkolenia lub prelekcji. Potwierdzenie zapisu zostanie przesłane na Twoją skrzynkę mailową.'
      },
      {
        title: '09. Na szkolenie, w którym chcę wziąć udział, nie ma już miejsc. Czy mogę zapisać się na listę rezerwową?',
        text: 'Tak, za pomocą tego samego guzika :) Jeśli ktoś z listy podstawowej nie przyjdzie lub spóźni się na szkolenie, możesz śmiało zająć jego/jej miejsce!'
      },
      {
        title: '10. Czy muszę wypełniać swoje CV w systemie?',
        text: 'Jest to opcjonalne, ale rekomendowane. Dzięki wypełnionemu CV pracodawcy łatwiej Cię odnajdą w systemie i być może zatrudnią (nawet, jeśli już będzie po targach). Wypełnienie CV jest obligatoryjne wówczas, gdy chcesz wziąć udział w Szybkiej Rekrutacji.'
      },
      {
        title: '11. Jak przygotować się do udziału w targach?',
        text: 'Zapoznaj się z wystawcami (www.careerexpo.pl/firmy) i wybierz te, z którymi chcesz porozmawiać. Dowiedz się o nich czegoś więcej, zrób notatki - to zaprocentuje podczas rozmowy! Przygotuj się do niej jak do rozmowy kwalifikacyjnej, bądź pewny siebie i znaj swoją wartość. Przekaż rekruterowi swoje CV (wydrukuj ich wcześniej przynajmniej kilka). Jeśli masz wątpliwości, czy jest zbudowane poprawnie - zabierz je ze sobą na targi, skorzystaj z naszych doradców na stanowisku konsultacyjnym i wydrukuj nowy dokument w punkcie informacyjnym na targach. Warto, żebyś przed targami zapisał się również na interesujące Cię szkolenia i prelekcje, wziął w nich czynny udział i wyniósł jak najwięcej.'
      },
      {
        title: '12. Czy powinienem mieć przy sobie swoje dokumenty aplikacyjne?',
        text: 'Nie zaszkodzi! Jeśli jednak zapomniałeś je ze sobą zabrać lub nie masz możliwości wydrukowania dokumentów, możesz to zrobić bezpośrednio na targach na naszym stoisku informacyjnym. Za darmo wydrukujemy Ci do 10 egzemplarzy Twojego CV (kopie czarno-białe).'
      },
      {
        title: '13. Gdzie odbywają się szkolenia/prelekcje?',
        text: 'Informacje o miejscu i godzinie szkolenia lub prelekcji są dostępne na naszej stronie internetowej w harmonogramie wydarzeń. Dodatkowo każdy zapisany uczestnik szkolenia lub prelekcji otrzymuje maila z najważniejszymi informacjami organizacyjnymi. Jeśli jednak wciąż masz wątpliwości, po wejściu na halę, udaj się do naszego punktu informacyjnego. Chętnie pomożemy!'
      },
      {
        title: '14. Co zrobić, jeśli spóźniłem się na szkolenie?',
        text: 'Uchyl drzwi i jeśli w sali znajdziesz miejsce siedzące, zajmij je bez zwracania na siebie uwagi prowadzącego i uczestników.'
      },
      {
        title: '15. Pracuję i mogę przyjechać dopiero o 17:00, godzinę przed zamknięciem - czy udział w targach o takiej porze ma sens?',
        text: '90% pracodawców zostaje z nami do ostatniej minuty, więc tak, ma to sens :)'
      },
      {
        title: '16. Gdzie znajdę więcej wskazówek, jak znaleźć pracę na targach?',
        text: 'Na początek, zajrzyj do zakładki “Wiedza” na naszej stronie internetowej careerexpo.pl/wiedza/eksperci. Znajdziesz tam sporo ciekawych tekstów, porad i praktycznych informacji, które przybliżą Ci specyfikę rynku pracy i oczekiwania pracodawców, a także podpowiedzą Ci, jak skutecznie aplikować. Zapraszamy również do lektury naszego bloga blog.careerexpo.pl/, gdzie w swobodny sposób podejmujemy zagadnienia i dylematy towarzyszące poszukiwaniu pracy. Warto być także na bieżąco z naszym fanpage’m na Facebooku www.facebook.com/pl.careerEXPO/ Polub go, zapisz się do wydarzenia w Twoim mieście i zaproś znajomych - niech również skorzystają :)'
      },
      {
        title: '17. Czy dla uczestników targów-studentów są zorganizowane zwolnienia rektorskie?',
        text: 'Niestety nie mamy na to wpływu, ALE na stanowisku informacyjnym możemy przygotować dla Ciebie imienne zaświadczenie o udziale w targach, które przez wiele uczelni jest respektowane jako usprawiedliwienie nieobecności na zajęciach.'
      },
      {
        title: '18. Jak powinienem się ubrać na targi?',
        text: 'Pamiętaj, że pierwsze wrażenie jest bardzo ważne. Dlatego ubierz się schludnie i elegancko, ale nie przesadnie - najważniejsze, żebyś podczas rozmowy z rekruterami czuł się komfortowo i swobodnie. '
      },
      {
        title: '19. Nie znalazłem odpowiedzi na moje pytanie - z kim mogę się skontaktować?',
        text: 'Napisz do nas wiadomość prywatną na naszym fanpage: www.facebook.com/pl.careerEXPO lub wyślij maila z pytaniem na adres: info@careerexpo.pl'
      }
    ]
  },
  footer: {
    leftColumn: {
      title: 'Dla odwiedzających',
      linksList: [
        {
          label: 'Harmonogram targów',
          link: '/#trainings',
          type: 'internal'
        },
        {
          label: 'Pracodawcy',
          link: '/#companies',
          type: 'internal'
        },
        // {
        //   label: 'Partnerzy',
        //   link: '/partnerzy',
        //   type: 'internal'
        // },
        {
          label: 'Oferty Pracy',
          link: '/oferty-pracy',
          type: 'internal'
        },
        {
          label: 'Wiedza',
          link: '/artykuly-eksperckie',
          type: 'internal'
        }
      ]
    },
    centerColumn: {
      title: 'Współpraca',
      linksList: [
        {
          label: 'Dla firm',
          link: '/dla-firm',
          type: 'internal'
        },
        // {
        //   label: 'Partnerzy',
        //   link: '/partnerzy',
        //   type: 'internal'
        // },
        {
          label: 'Kontakt',
          link: '/kontakt',
          type: 'internal'
        },
        {
          label: 'Logowanie',
          link: '/logowanie-dla-firm',
          type: 'internal'
        }
      ]
    },
    rightColumn: {
      title: 'Targi pracy',
      linksList: [
        // {
        //   label: 'Partnerzy',
        //   link: '/partnerzy',
        //   type: 'internal'
        // },
        // {
        //   label: 'Partnerzy',
        //   link: '/partnerzy',
        //   type: 'internal'
        // }
      ]
    }
  },
  form: {
    creatorCv: {
      creatorCvTitle: 'TODO',
      creatorCvStepOne: {
        description: 'TODO'
      },
      creatorCvStepTwo: {
        description: 'TODO'
      },
      creatorCvStepThree: {
        description: 'TODO'
      },
      creatorCvSteps: {
        stepsList1: [
          {
            link: '/kreator-cv/podstawowe-dane',
            number: '1',
            title: 'Podstawowe dane',
            type: 'isCurrent',
            withLinks: true
          },
          {
            link: '/kreator-cv/doswiadczenia',
            number: '2',
            title: 'Doświadczenia',
            type: 'isNext',
            withLinks: true
          },
          {
            link: '/kreator-cv/szablon',
            number: '3',
            title: 'Szablon',
            type: 'isNext',
            withLinks: true
          }
        ],
        stepsList2: [
          {
            link: '/kreator-cv/podstawowe-dane',
            number: '1',
            title: 'Podstawowe dane',
            type: 'isPrevious',
            withLinks: true
          },
          {
            link: '/kreator-cv/doswiadczenia',
            number: '2',
            title: 'Doświadczenia',
            type: 'isCurrent',
            withLinks: true
          },
          {
            link: '/kreator-cv/szablon',
            number: '3',
            title: 'Szablon',
            type: 'isNext',
            withLinks: true
          }
        ],
        stepsList3: [
          {
            link: '/kreator-cv/podstawowe-dane',
            number: '1',
            title: 'Podstawowe dane',
            type: 'isPrevious',
            withLinks: true
          },
          {
            link: '/kreator-cv/doswiadczenia',
            number: '2',
            title: 'Doświadczenia',
            type: 'isPrevious',
            withLinks: true
          },
          {
            link: '/kreator-cv/szablon',
            number: '3',
            title: 'Szablon',
            type: 'isCurrent',
            withLinks: true
          }
        ]
      }
    },
    companySteps: {
      companyStepOne: {
        description: 'Nawet największa podróż zaczyna się od pierwszego kroku. Podaj swoje dane i pochwal się światu Twoją firmą.'
      },
      companyStepTwo: {
        description: 'Dlaczego robicie to, co robicie? Ale co ważniejsze - dlaczego inni mieliby do Was dołączyć? To idealny czas na inspirację.'
      },
      companyStepThree: {
        description: 'Kogo szukacie i kto jest odpowiedzialny za rekrutację? Nie bądź anonimowy - to Twoja szansa na przyciągnięcie prawdziwych talentów.'
      },
      companyStepFour: {
        description: 'Pokaż kandydatom, co Twoja firma może zaoferować w zamian za ich umiejętności (zakładka: Benefity). Sukcesami firmy też warto się pochwalić ;-) (zakładka: Wyróżnienia)'
      },
      companyStepFive: {
        description: 'Wszyscy chcemy rozwijać się oraz pracować z najlepszymi i dla najlepszych. Podziel się z innymi swoją wiedzą i doświadczeniem, aby pomóc im wybrać właściwą ścieżkę kariery.',
        guidelinesLabel: 'Wytyczne',
        guidelinesText: 'Artykuły oraz informacje o autorze dodawane są przez przedstawicieli firm samodzielnie. Długość artykułu - długości artykułu: min. 5500 znaków, max 8500 znaków ze spacjami. Zaleca się dołączenie do treści uzupełniających ją grafik i zdjęć (jeśli zostanie to pominięte, administrator serwisu sam dopasuje odpowiednie materiały do publikacji). Grafika nagłówkowa powinna mieć wymiary 930x380 pikseli. Teksty na bieżąco są weryfikowane i po akceptacji publikowane. Zastrzegamy sobie prawo do nieopublikowania artykułu niespełniającego wytycznych (np. krótszego niż 5500 znaków, reklamowego, zawierającego błędy ortograficzne czy logiczne, pozbawione biogramu autora itp.)',
        howArticleShouldLookLabel: 'Jak powinien wyglądać artykuł?',
        howArticleShouldLookText: 'Artykuły eksperckie powinny mieć charakter merytoryczny, nie informacyjny. Zachęcamy do poruszania tematyki, która będzie ciekawa dla odwiedzających. Dotychczas napisane artykuły znajdą Państwo na stronie: www.targipracy.szczecin.pl (zakładka „Wiedza”). Mogą one stanowić dla Państwa wskazówkę.',
        howArticleShouldNotLookLabel: 'Jak NIE powinien wyglądać artykuł?',
        howArticleShouldNotLookText: 'Artykuły eksperckie nie mogą mieć charakteru stricte reklamowego, nie mogą zatem dotyczyć historii, produktów firmy, a także jej programów praktyk, procesów rekrutacyjnych i innych zagadnień bezpośrednio dotyczących tej konkretnej organizacji. Takie artykuły nie przejdą weryfikacji.',
        visibleText: 'Artykuły eksperckie to materiały umieszczone w sekcji “Wiedza”, których zadaniem jest przygotowanie odwiedzających do targów i zwiększenie ich świadomości zawodowej. Autor wciela się tu w rolę profesjonalnego doradcy reprezentującego daną organizację. Pisze tekst dotyczący wybranego zagadnienia leżącego w kręgu tematów związanych z rekrutacją, rynkiem pracy, rozwojem osobistym. Mile widziane są też teksty branżowe, case studies. Jest to atrakcyjna forma wspierająca wizerunek eksperta, która wzbudza zaufanie zarówno poszukujących pracy, jak i partnerów biznesowych.'
      },
      companyStepsList1: [
        {
          link: '/platforma/podstawowe-dane',
          number: '1',
          title: 'Podstawowe dane',
          type: 'isCurrent',
          withLinks: false
        },
        {
          link: '/platforma/szczegoly',
          number: '2',
          title: 'Szczegóły',
          type: 'isNext',
          withLinks: false
        },
        {
          link: '/platforma/rekrutacja',
          number: '3',
          title: 'Rekrutacja',
          type: 'isNext',
          withLinks: false
        },
        {
          link: '/platforma/benefity-i-wyroznienia',
          number: '4',
          title: 'Benefity i wyróżnienia',
          type: 'isNext',
          withLinks: false
        },
        {
          link: '/platforma/edukacja',
          number: '5',
          title: 'Edukacja',
          type: 'isNext',
          withLinks: false
        }
      ],
      companyStepsList2: [
        {
          link: '/platforma/podstawowe-dane',
          number: '1',
          title: 'Podstawowe dane',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/szczegoly',
          number: '2',
          title: 'Szczegóły',
          type: 'isCurrent',
          withLinks: false
        },
        {
          link: '/platforma/rekrutacja',
          number: '3',
          title: 'Rekrutacja',
          type: 'isNext',
          withLinks: true
        },
        {
          link: '/platforma/benefity-i-wyroznienia',
          number: '4',
          title: 'Benefity i wyróżnienia',
          type: 'isNext',
          withLinks: true
        },
        {
          link: '/platforma/edukacja',
          number: '5',
          title: 'Edukacja',
          type: 'isNext',
          withLinks: true
        }
      ],
      companyStepsList3: [
        {
          link: '/platforma/podstawowe-dane',
          number: '1',
          title: 'Podstawowe dane',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/szczegoly',
          number: '2',
          title: 'Szczegóły',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/rekrutacja',
          number: '3',
          title: 'Rekrutacja',
          type: 'isCurrent',
          withLinks: false
        },
        {
          link: '/platforma/benefity-i-wyroznienia',
          number: '4',
          title: 'Benefity i wyróżnienia',
          type: 'isNext',
          withLinks: true
        },
        {
          link: '/platforma/edukacja',
          number: '5',
          title: 'Edukacja',
          type: 'isNext',
          withLinks: true
        }
      ],
      companyStepsList4: [
        {
          link: '/platforma/podstawowe-dane',
          number: '1',
          title: 'Podstawowe dane',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/szczegoly',
          number: '2',
          title: 'Szczegóły',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/rekrutacja',
          number: '3',
          title: 'Rekrutacja',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/benefity-i-wyroznienia',
          number: '4',
          title: 'Benefity i wyróżnienia',
          type: 'isCurrent',
          withLinks: false
        },
        {
          link: '/platforma/edukacja',
          number: '5',
          title: 'Edukacja',
          type: 'isNext',
          withLinks: true
        }
      ],
      companyStepsList5: [
        {
          link: '/platforma/podstawowe-dane',
          number: '1',
          title: 'Podstawowe dane',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/szczegoly',
          number: '2',
          title: 'Szczegóły',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/rekrutacja',
          number: '3',
          title: 'Rekrutacja',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/benefity-i-wyroznienia',
          number: '4',
          title: 'Benefity i wyróżnienia',
          type: 'isPrevious',
          withLinks: true
        },
        {
          link: '/platforma/edukacja',
          number: '5',
          title: 'Edukacja',
          type: 'isCurrent',
          withLinks: false
        }
      ],
      companyStepsTitle: 'Stwórz swój unikalny profil Pracodawcy w 5 krokach'
    },
    labels: {
      buttonNextLabel: 'Następny',
      buttonNextStepLabel: 'Następny krok',
      buttonPrevLabel: 'Wstecz',
      buttonPreview: 'Podgląd',
      buttonResetLabel: 'Wyczyść',
      buttonSaveLabel: 'Zapisz',
      buttonSelectLabel: 'Wybierz',
      buttonSkipLabel: 'Pomiń',
      fastRecruitment: 'Szybkie rekrutacje',
      favouriteEmployers: 'Ulubieni pracodawcy',
      requiredFieldsText: '* Pola obowiązkowe',
      titleLabel: 'Przygotuj się na targi pracy Career EXPO w 3 krokach!',
      trainingsTimetableLabel: 'Harmonogram szkoleń'
    },
    userDataFormLabels: {
      userAddressLabel: 'Adres',
      userCityLabel: 'Miasto',
      userCountryLabel: 'Kraj',
      userCustomTextLabel: 'Kilka słów o sobie',
      userDateOfBirthLabel: 'Data urodzenia',
      userEmailLabel: 'Adres e-mail',
      userNameLabel: 'Imię',
      userNationalityLabel: 'Obywatelstwo',
      userPhoneLabel: 'Telefon',
      userPictureLabel: 'Twoje zdjęcie',
      userPostCodeLabel: 'Kod pocztowy',
      userSocialMediaDescriptionLabel: 'Social Media',
      userSocialMediaDescriptionText: 'Tutaj możesz dołączyć linki do swoich profili w Social Media oraz do swoich portfolio.',
      userSocialMediaLinkLabel: 'Link',
      userSocialMediaTitleLabel: 'Profile Social Media',
      userSurnameLabel: 'Nazwisko'
    },
    stepsList1: [
      {
        link: '/platforma/podstawowe-dane',
        number: '1',
        title: 'Podstawowe dane',
        type: 'isCurrent',
        withLinks: false
      },
      {
        link: '/platforma/moje-szkolenia',
        number: '2',
        title: 'Zapisy na szkolenia',
        type: 'isNext',
        withLinks: false
      },
      {
        link: '/platforma/pobierz-bilet',
        number: '3',
        title: 'Pobieram bilet',
        type: 'isNext',
        withLinks: false
      }
    ],
    stepsList2: [
      {
        link: '/platforma/podstawowe-dane',
        number: '1',
        title: 'Podstawowe dane',
        type: 'isPrevious',
        withLinks: true
      },
      {
        link: '/platforma/moje-szkolenia',
        number: '2',
        title: 'Zapisy na szkolenia',
        type: 'isCurrent',
        withLinks: false
      },
      {
        link: '/platforma/pobierz-bilet',
        number: '3',
        title: 'Pobieram bilet',
        type: 'isNext',
        withLinks: false
      }
    ],
    stepsList3: [
      {
        link: '/platforma/podstawowe-dane',
        number: '1',
        title: 'Podstawowe dane',
        type: 'isPrevious',
        withLinks: true
      },
      {
        link: '/platforma/moje-szkolenia',
        number: '2',
        title: 'Zapisy na szkolenia',
        type: 'isPrevious',
        withLinks: true
      },
      {
        link: '/platforma/pobierz-bilet',
        number: '3',
        title: 'Pobieram bilet',
        type: 'isCurrent',
        withLinks: false
      }
    ],
    stepOne: {
      description: 'Podaj swoje podstawowe dane, aby móc uczestniczyć w targach. W kolejnym kroku zapiszesz się na szkolenia, a następnie pobierzesz bezpłatny bilet wstępu.',
      subtitle: 'Targi Pracy Career EXPO, 27.03.2019, 10:00-18:00, Aleja Śląska 1 - Stadion Wrocław'
    },
    stepTwo: {
      description: 'Pomożemy Ci stać się lepszym. Wybierz obszary, które Cię interesują, a następnie zapisz się na szkolenia, które podniosą Twoje kompetencje!',
      subtitle: 'Wybierz interesujące Cię obszary szkoleń i prelekcji:'
    },
    stepThree: {
      description: 'Pobierz bezpłatny bilet wstępu na targi pracy Career EXPO:',
      descriptionTwo: 'Uzupełnij dane i zdobądź punkty za wypełnienie wszystkich formularzy',
      subtitle: 'Bądź wyjątkowy',
      subtitleTwo: 'Podstawowe dane',
      subtitleThree: 'Edukacja (Twoje ostatnie najważniejsze szkoły)',
      subtitleFour: 'Doświadczenie',
      subtitleFive: 'Języki obce',
      subtitleSix: 'Umiejętności'
    },
    stepFour: {
      description: 'Pomożemy Ci znaleźć idealną firmę, która odpowiada Twoim wartościom. Najpierw jednak określ, jak chciałbyś, aby wyglądała Twoja zawodowa przyszłość!',
      employersLabel: 'pracodawców',
      employersAboveLabel: 'pracodawców powyżej',
      foundLabel: 'Znaleziono',
      subtitleValues: 'Najpierw wybierz 10 wartości, które są dla Ciebie istotne.',
      subtitleImportantValues: 'Następnie z tych 10 wybierz 3 najważniejsze (zmienią kolor na malinowy).',
      subtitleTwo: 'Wybierz branżę, którą chciałbyś współtworzyć i rozwijać:',
      valueLabel: 'wartości'
    },
    stepFive: {
      description: 'Na Career EXPO czeka Cię mnóstwo bardzo interesujących wydarzeń. Pobierz harmonogram tego wyjątkowego dnia!',
      buttonDownloadSummary: 'Pobierz podsumowanie',
      getTicket: 'Pobierz bilet',
      subtitle: 'Twój unikalny bilet',
      subtitleTwo: 'Zobacz, z jakimi Pracodawcami będziesz miał szansę porozmawiać podczas targów pracy Career EXPO!'
    }
  },
  homepageMenu: {
    linksList: [
      {
        inNewWindow: false,
        label: 'Harmonogram targów',
        link: '/#zones'
      },
      {
        inNewWindow: false,
        label: 'Pracodawcy',
        link: '/#companies'
      },
      {
        inNewWindow: false,
        label: 'Oferty pracy',
        link: '/oferty-pracy'
      },
      {
        inNewWindow: false,
        label: 'Dla firm',
        link: '/dla-firm'
      },
      ,
      {
        inNewWindow: false,
        label: 'Wiedza',
        link: '/artykuly-eksperckie'
      }
    ]
  },
  locations: {
    labels: {
      addToCalendarButtonLabel: 'Dodaj do kalendarza',
      buttonLabel: 'Znajdź połączenie',
      dateAndTimeLabel: 'Data i godzina',
      placeLabel: 'Miejsce'
    }
  },
  registryAndLogin: {
    labels: {
      doYouAlreadyHaveAnAccountLabel: 'Masz już konto?',
      forgotPassword: 'Zapomniałem hasła',
      gotAcquaintedWithLabel: 'zapoznałem/am się z',
      loginLabel: 'Zaloguj się',
      privacyPolicyLabel: 'Politykę Prywatności',
      registryLabel: 'Załóż profil',
      regulationsLabel: 'Regulamin',
      rightSideDescriptionLabel: 'Chcesz podnieść swoje kwalifikacje, a może dowiedzieć się, w czym tkwi tajemnica sukcesu liderów biznesu? Wybierz coś dla siebie z naszej listy szkoleń i prelekcji z ciekawymi gośćmi - zapisz się i chłoń wiedzę.',
      rightSideTitleLabel: 'Prelekcje i szkolenia',
      siteNameLabel: 'Career EXPO',
      youDontHaveAnAccountLabel: 'Nie masz konta?'
    }
  },
  recruitment: {
    labels: {
      assessmentCenterLabel: 'Assesment Center',
      departmentsLabel: 'Działy',
      employmentTypesLabel: 'Rodzaj zatrudnienia',
      jobInterviewLabel: 'Rozmowa kwalifikacyjna',
      needsCvLabel: 'Curriculum Vitae (CV)',
      needsMotivationalListLabel: 'List motywacyjny',
      placeLabel: 'Miejsca pracy',
      preferredCandidatesLabel: 'Preferowani kandydaci',
      preferredDegreeCoursesLabel: 'Kierunki studiów',
      recruiterLabel: 'Osoba odpowiedzialna za rekrutacje',
      whoWeAreLookingForLabel: 'Kogo szukamy'
    }
  },
  SocialMediaCE: {
    facebook: 'https://www.facebook.com/TargiPracySzczecin/',
    linkedin: '',
    twitter: 'https://twitter.com/targipracySZN',
    youtube: '',
    instagram: 'https://www.instagram.com/targipracyszczecin/'
  },
  subPages: {
    contact: {
      companyAddress: 'ul. Władysława Szafera 3/5/7',
      companyCity: '71-246 Szczecin',
      companyKRS: '0000332292',
      companyNIP: '8513099114',
      companyName: 'Enea Arena',
      companyREGON: '320697690',
      pageTitle: 'Kontakt',
      staffList: [
        {
          email: 'zapraszamy@targipracy.szczecin.pl',
          image: karolinaMerdaImagePath,
          name: 'Maciej',
          phone: '+48913508262',
          phoneLabel: '91 350 82 62',
          position: 'Koordynator Targów Pracy',
          surname: 'Patynowski'
        },
        // {
        //   email: 'biuro@targipracy.szczecin.pl',
        //   image: jacekCiechanowskiImagePath,
        //   name: 'Andrzej',
        //   phone: '+ 48506549571',
        //   phoneLabel: '+ 48 506 549 571',
        //   position: 'Rzecznik prasowy Targów Pracy',
        //   surname: 'Ulhurski'
        // }
      ]
    }
  },
  summary: {
    labels: {
      buttonBackToStepLabel: 'Wróć do kroku',
      fastRecruitment: 'Szybkich Rekrutacjach',
      favouriteEmployers: 'ulubionych pracodawców',
      trainings: 'szkolenia',
      trainingsLabel: 'Harmonogram szkoleń',
      youHave: 'Masz',
      youHaveAssignedFor: 'Zapisałeś się na',
      youParticipateIn: 'Bierzesz udział w'
    }
  },
  steps: {
    landingPageSteps: {
      labels: {
        titleLabel: 'To jak, widzimy się na targach?',
        buttonLabel: 'Zdobądź bilet'
      },
      stepsList: [
        {
          description: 'i uzupełnij podstawowe dane.',
          number: '1',
          title: 'Załóż konto',
          type: 'isCurrent'
        },
        {
          description: 'na najskuteczniejsze targi pracy we Wrocławiu.',
          number: '2',
          title: 'Pobierz bilet',
          type: 'isNext'
        },
        {
          description: 'Weź udział w naszych szkoleniach, które podniosą Twoją wartość na rynku pracy!',
          number: '3',
          title: 'Zdobądź wiedzę',
          type: 'isNext'
        },
        {
          description: 'Na miejscu nasi eksperci doradzą Ci, co zrobić, aby Twoje CV była skuteczniejsze.',
          number: '4',
          title: 'Skonsultuj CV',
          type: 'isNext'
        },
        {
          description: 'Sprawdź, jakie możliwości oferują Ci Pracodawcy z Twojego regionu i weź udział w Szybkich Rekrutacjach!',
          number: '5',
          title: 'Aplikuj!',
          type: 'isNext'
        }
      ]
    }
  },
  tabs: {
    tabsList: [
      {
        label: 'Ogólne',
        value: 'general'
      },
      {
        label: 'Rekrutacja',
        value: 'recruitment'

      },
      // {
      //   label: 'Aktualności',
      //   value: 'general'
      // },
      {
        label: 'Benefity',
        value: 'benefits'
      },
      {
        label: 'Wyróżnienia',
        value: 'awards'
      },
      {
        label: 'Oddziały',
        value: 'offices'
      },
      {
        label: 'Oferty pracy',
        value: 'jobs'
      }
    ]
  },
  topMenu: {
    linksList: [
      {
        inNewWindow: false,
        label: 'Harmonogram targów',
        link: '#trainings'
      },
      {
        inNewWindow: false,
        label: 'Pracodawcy',
        link: '#companies'
      },
      {
        inNewWindow: false,
        label: 'Oferty pracy',
        link: '/oferty-pracy'
      },
      {
        inNewWindow: false,
        label: 'Dla firm',
        link: '/dla-firm'
      },
      ,
      {
        inNewWindow: false,
        label: 'Wiedza',
        link: '/artykuly-eksperckie'
      }
    ],
    linksListJobs: [
      {
        inNewWindow: false,
        label: 'Harmonogram targów',
        link: '/#trainings'
      },
      {
        inNewWindow: false,
        label: 'Pracodawcy',
        link: '/#companies'
      },
      {
        inNewWindow: false,
        label: 'Oferty pracy',
        link: '/oferty-pracy'
      },
      {
        inNewWindow: false,
        label: 'Dla firm',
        link: '/dla-firm'
      },
      ,
      {
        inNewWindow: false,
        label: 'Wiedza',
        link: '/artykuly-eksperckie'
      }
    ]
  },
  trainings: {
    labels: {
      trainingsButtonBuyLabel: 'Zapisz się',
      trainingsButtonUnBuyLabel: 'Wypisz się',
      trainingsDescriptionLabel: 'Opis',
      trainingsHourFieldLabel: 'Godzina',
      trainingsPlaceLabel: 'Scena',
      trainingsSpeakersFieldLabel: 'Prelegenci',
      trainingsSubjectFieldLabel: 'Temat',
      trainingsTagsListLabel: 'Tagi'
    }
  },
  login: 'Zaloguj się',
  logout: 'Wyloguj się',
  register: 'Zdobądź bilet',
  sectionOne: {
    title: 'Szukasz pracy, stażu, praktyk? Przyjdź na Targi Pracy!',
    description: 'W Enea Arena w Szczecinie spotkasz najlepszych pracodawców z kraju i regionu'
  },
  sectionTwo: {
    title: 'Targi Pracy Szczecin',
    icon: 'pin',
    alt: 'icon pin',
    dates: '14.10.2020',
    time: '10:00 - 17:00'
  },
  ForCompanies: {
    text_1: '<h2>Targi Pracy Szczecin</h2> <p>Targi Pracy w Szczecinie to dla firm i instytucji nie tylko doskonała okazja na poznanie oczekiwań i potrzeb pracowników, ale także świetny sposób promocji własnej marki. Impreza odbywa się w hali widowiskowo-sportowej ENEA ARENA przy ul. Władysława Szafera 3/5/7 w Szczecinie!</p>',
    text_2: '<h2>Standardowy pakiet wystawienniczy</h2><p>To opcja, z której korzysta większość wystawców. Pakiet standardowy to:</p> <ul><li>stanowisko targowe o wymiarach 2x2 metry (oczywiście jest możliwość rozbudowy stoiska o dodatkową powierzchnię oraz wyposażenie),</li><li>wyposażenie stanowiska: stolik, 2 krzesła, tzw. lada systemowa, kosz na śmieci oraz wieszak,</li><li>nazwa Państwa Firmy nad stanowiskiem targowym (nadruk),</li><li>przyłączenie do gniazda 230 V,</li><li>obsługa techniczna stanowiska,</li><li>dostęp do internetu Wi-Fi w czasie trwania Targów,</li><li>catering (ciepły posiłek, kanapki, ciasto, kawa/herbata/soki),</li><li>wizytówka firmy na stronie internetowej Targów w spisie wystawców,</li><li>możliwość dodania 10 ofert pracy na stronie internetowej Targów Pracy,</li><li>opis firmy w katalogu pracodawców (nakład 1500 egz.)</li></ul> <h2>Pakiety dodatkowe</h2> <p>Pakiety dodatkowe to:</p> <ul><li>nawet pięciokrotnie większa powierzchnia wystawiennicza,</li><li>możliwość wygłoszenia prelekcji/prezentacji na temat Firmy,</li><li>wyróżniona wizytówka Firmy na stronie targipracy.szczecin.pl oraz możliwość dodania nielimitowanej liczby ofert pracy,</li><li>logo Firmy na plakatach, ulotkach, banerach, koszulkach, ekranie diodowym nad „miasteczkiem” targowym...</li><li>nazwa Firmy w spocie radiowym promującym Targi Pracy,</li><li>udział przedstawiciela Firmy w relacji „na żywo” z Targów Pracy (stream w internecie)</li><li>całostronne ogłoszenie w oficjalnym katalogu pracodawców...</li></ul>'
  },
  ukrPage: {
    text_1: '<h2>Про ярмарок вакансій у Щецині</h2><p>Ви вже відправили багато резюме у відповідь на оголошення з газет або інтернет-порталів? Але ви досі не можете знайти відповідну для себе роботу, змінити ту, що маєте, на кращу або таку, від якої хочете отримати більше задоволення. Не знаєте, як це зробити?</p><p>Відвідайте ярмарок вакансій, який відбудеться у спортивно- розважальному комплексі ENEA ARENA у Щецині. Це – чудова можливість отримати інформацію про компанію з перших уст та налагодити контакт з майбутнім роботодавцем.</p><p>ОЗНАЙОМТЕСЯ ЗІ СПИСКОМ РОБОТОДАВЦІВ <a href="https://targipracy.szczecin.pl/#companies">[натисніть тут]</a></p><p>З кожним роком цей захід залучає десятки експонентів з конкретними пропозиціями щодо роботи, як для студентів й випускників, так і для осіб, які шукають зміни у своєму професійному житті. Тут можна знайти пропозиції практично в усіх галузях і для кваліфікованих працівників, і для людей, які роблять свої перші кроки на ринку праці.</p><p>Де: ENEA ARENA у Щецині, вул. Владислава Шафера 3/5/7</p>',
    text_2: '<ul><li><strong>Організатор</strong>: Польська фундація підприємницьких спілок</li><li><span style="line-height:normal">Вхід для відвідувачів <strong>безкоштовний!</strong></span></li></ul>',
    text_3: '<h2>Понад  100 роботодавців!</h2>',
    text_4: '<h2>Понад 2 000 пропозицій праці!</h2>',
    text_5: '<h2>Мапа маршруту до Ярмарку вакансій у Щецині</h2><p>Виставковий зал <strong>ENEA ARENA</strong> у Щецині (Владислав Шафера, 3/5/7)</p><iframe style="border:0;" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCJMzPr06tNkQ6l8-Gwv9VxQ3uk_hqAZcY&amp;zoom=14&amp;q=Netto%20Arena&amp;maptype=roadmap" width="100%" height="500" frameborder="0"> <iframe></iframe><h2>Що таке Ярмарок вакансій?</h2><p>Ярмарок вакансій – це, насамперед, можливість зустрітися одночасно і в одному місці з представниками різних компаній та установ і поспілкуватися з ними про можливості працевлаштування, стажування або проходження практики. Ярмарок вакансій є своєрідною платформою, що дозволяє встановлювати необмежений та прямий контакт між обома сторонами ринку праці (роботодавці – шукачі роботи).</p><p>"Невимушений", тому що захід традиційно відбувається у розкутій атмосфері. Нема нічого спільного зі стресовими інтерв&#39;ю та розпитуванням кандидатів щодо їх знань й кваліфікацій. Це також чудова можливість досягти потрібних людей за допомогою резюме…</p><h2>На кого націлений Ярмарок вакансій?</h2><p>Ми запрошуємо на ярмарок усіх мешканців воєводства, але, перш за все, студентів та випускників західнопоморських університетів, які або шукають свій перший професійний досвід (стажування, практика, зайнятість), або вже зараз – під час навчання – хочуть дізнатися, що від них очікує "вимріяний роботодавець" за кілька років, коли вони залишать університетські стіни й вийдуть на ринок праці.</p><p><br> Ярмарок вакансій також відкритий для людей, які хочуть змінити своє професійне життя, або просто шукають роботу. Участь у заході для усіх, звичайно, безкоштовна.</p><h2>Яка є мета Ярмарку вакансій?</h2><p>Ярмарок вакансій спрямований на полегшення для мешканців нашого міста та регіону пошуку (зміни) роботи або набуття знань, що дозволить їм знайти правильний напрямок на шляху їх розвитку.&nbsp;<br> <br> Польська фундація підприємницьких спілок, організатор Ярмарку вакансій, прагне створити простір для вільних зустрічей та бесід. <strong>Форма події сприяє взаємодії, обміну контактами та створенню цінних зв’язків.</strong><br> <br> У цьому році на Ярмарку будуть представлені компанії &nbsp;з фінансової, ІТ, торгівельної та виробничої галузей. &nbsp;<br> <br> Експоненти цьогорічного Ярмарку вакансій у цілому мають понад 2 000 пропозицій стосовно роботи, стажування та практики, як для тих, хто шукає перший професійний досвід, так і для фахівців з багатим послужним списком.<br> Особи, які цікавляться подальшим розвитком та підвищенням кваліфікації, зможуть ознайомитися з пропозиціями щодо навчання, які пропонують різни установи, або взяти участь у цікавих лекціях.</p><iframe id="element_1074_youtube" data-video-type="youtube" data-videoid="RJiI86C_x6c" data-controls="true" data-autoplay="false" data-loop="false" data-muted="false" class="youtubeVideo" allowfullscreen="1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" src="https://www.youtube.com/embed/RJiI86C_x6c?modestbranding=1&amp;controls=1&amp;rel=0&amp;showinfo=1&amp;enablejsapi=1&amp;origin=https%3A%2F%2Ftargipracy.szczecin.pl&amp;widgetid=1" width="100%" height="500" frameborder="0"></iframe>'
  },
  sectionThree: {
    title: 'Prelekcje i szkolenia',
    description: 'Chcesz podnieść swoje kwalifikacje, a może dowiedzieć się, w czym tkwi tajemnica sukcesu liderów biznesu? Wybierz coś dla siebie z naszej listy szkoleń i prelekcji z ciekawymi gośćmi - zapisz się i chłoń wiedzę.',
    subtitle: {
      alt: 'icon tag',
      icon: 'tag',
      text: 'Co Cię interesuje? Wybierz obszary Twojego rozwoju:'
    }
  },
  sectionFour: {
    title: 'Prelekcje i szkolenia',
    description: 'Chcesz podnieść swoje kwalifikacje, a może dowiedzieć się w czym tkwi tajemnica sukcesu liderów biznesu? Wybierz coś dla siebie z listy prelekcji i szkoleń - zapisz się i chłoń wiedzę!',
    legend: {
      hour: 'Godzina',
      subject: 'Temat',
      speakers: 'Prelegenci'
    }
  },
  sectionFive: {
    title: 'Pracodawcy',
    description: 'Poznaj firmy i sprawdź oferty, które pojawią się w Enea Arena w Szczecinie na największych zachodniopomorskich Targach Pracy.',
    subtitle: {
      alt: 'icon star',
      icon: 'star',
      text: 'Wybierz poniżej branżę:'
    }
  },
  sectionSeven: {
    title: 'Strefy',
    description: 'Zobacz, dlaczego jeszcze warto przyjść na targi pracy Career EXPO!'
  },
  sectionEight: {
    createCV: 'Stwórz CV'
  },
  copyright: '© Wszelkie prawa zastrzeżone - Targi Pracy Szczecin',
  loginAndRegisterSliderItems: [
    {
      image: testImage,
      isSelected: false,
      text: '',
      title: ''
    },
    {
      image: testImage,
      isSelected: true,
      text: 'Chcesz podnieść swoje kwalifikacje, a może dowiedzieć się w czym tkwi tajemnica sukcesu liderów biznesu? Wybierz coś dla siebie z listy prelekcji i szkoleń - zapisz się i chłoń wiedzę! Career EXPO przyciąga najlepszych trenerów i szkoleniowców.',
      title: 'Ucz się od najlepszych'
    },
    {
      image: testImage,
      isSelected: false,
      text: 'Wygeneruj piękne i skuteczne CV, a potem skonsultuj je z naszymi ekspertami już bezpośrednio na wydarzeniu. Zrobisz sobie również profesjonalne zdjęcie. Jednym słowem - zmaksymalizujesz szanse!',
      title: 'Wygeneruj i skonsultuj CV!'
    }
  ],
  homepage: {
    cards: [
      {
        description: 'Rekruter potrzebuje tylko 14 sekund, aby odrzucić Twoje CV i 4 minuty, aby je zaakceptować. Spraw, by zainteresował się Twoją kandydaturą i zaprosił Cię do kolejnego etapu rekrutacji!',
        icon: HomepageCardClassroomIconPath,
        title: 'Stwórz skuteczne CV'
      },
      {
        description: 'Dla jednego międzynarodowa firma to zaleta, a dla drugiego wada.  Praca zdalna może być zbawieniem lub udręką. Pokażemy Ci, którzy Pracodawcy mają to, czego szukasz!',
        icon: HomepageCardSuccessIconPath,
        title: 'Określ cechy idealnego Pracodawcy'
      },
      {
        description: 'Przyjdź na targi pracy Career EXPO i przekonaj wybranego Pracodawcę, aby zatrudnił właśnie Ciebie! Weź udział w Szybkich Rekrutacjach, bezpłatnych szkoleniach i konsultacjach kariery.',
        icon: HomepageCardWorkIconPath,
        title: 'Poznajcie się… i aplikuj!'
      }
    ],
    cvTemplates: [
      {
        id: 1,
        image: HomepageCvTemplate1ImagePath,
        selected: false,
        title: 'Formalny'
      },
      {
        id: 2,
        image: HomepageCvTemplate2ImagePath,
        selected: false,
        title: 'Luźny'
      },
      {
        id: 3,
        image: HomepageCvTemplate3ImagePath,
        selected: false,
        title: 'Modernistyczny'
      }
    ],
    employersList: [
      HomepageEmployersAmazonImagePath,
      HomepageEmployersCeneoImagePath,
      HomepageEmployersVolvoImagePath,
      HomepageEmployersImpelImagePath,
      HomepageEmployersHpImagePath,
      HomepageEmployersQatarImagePath
    ],
    events: {
      labels: {
        dateLabel: 'Data',
        placeLabel: 'Miejsce'
      },
      primaryEvent: {
        date: '21.10.2019',
        name: 'Targi Pracy Wrocław',
        place: 'Stadion Wrocław'
      }
    },
    guidlineSteps: [
      {
        description: 'Wybierz jeden z wielu unikalnych szablonów, stworzonych przez grafików i rekruterów! Stwórz CV, które zachwyci Twojego przyszłego Pracodawcę.',
        number: 1,
        title: 'Wybierz szablon'
      },
      {
        description: 'Uzupełnij najważniejsze informacje i dodaj zdjęcie. Zapisz szablon jako jeden z wielu i dostosowuj go do różnych stanowisk, na które aplikujesz.',
        number: 2,
        title: 'Uzupełnij dane'
      },
      {
        description: 'Pobierz CV, by wykorzystać je do zewnętrznych rekrutacji lub aplikuj bezpośrednio z Career EXPO! Całkowicie bezpłatnie.',
        number: 3,
        title: 'Pobierz swoje CV'
      }
    ],
    squarePanels: {
      itemsList: [
        {
          description: 'Wolisz samodzielną pracę i formalną atmosferę?',
          icon: HomepageSquarePanel1IconPath,
          title: 'Mamy takich Pracodawców!'
        },
        {
          description: 'Preferujesz pracę zdalną i dużą dozę zaufania?',
          icon: HomepageSquarePanel2IconPath,
          title: 'Mamy takich Pracodawców!'
        },
        {
          description: 'Chcesz pracować w dużym zespole i jeździć na światowej rangi konferencje?',
          icon: HomepageSquarePanel3IconPath,
          title: 'Mamy takich Pracodawców!'
        }
      ],
      selected: {
        selected: true,
        title: 'Mamy takich Pracodawców!'
      }
    }
  },
  zones: {
    one: {
      description: 'Aplikuj i zdobądź wymarzoną pracę natychmiast! Strefa Szybkich Rekrutacji to miejsce dla osób, które oczekują szybkich informacji zwrotnych.',
      label: 'Strefa Szybkich Rekrutacji'
    },
    two: {
      description: 'Eksperci podpowiedzą Ci, co poprawić w Twoim CV, by było idealne. W tym miejscu zrobisz sobie również profesjonalne zdjęcie.',
      label: 'Strefa Konsultingu CV'
    },
    three: {
      description: 'Skorzystaj z mini sesji coachingowych, aby odpowiedzieć sobie na nurtujące Cię pytania. Odpowiedź jest w Tobie… Trzeba tylko odpowiednio zadać pytanie.',
      label: 'Strefa Coachingu'
    },
    four: {
      description: 'Odwiedź Strefę z najświeższymi ofertami pracy i zobacz, jakie wymagania mają Pracodawcy.',
      label: 'Strefa Ofert Pracy'
    },
    five: {
      description: 'Skończyły Ci się CV? Nie szkodzi. U nas wydrukujesz swoje dokumenty aplikacyjne.',
      label: 'Strefa Ksero'
    },
    six: {
      description: 'Zmęczyłeś się przemierzając labirynt stoisk? Odpocznij przy kawie i dźwiękach muzyki, by odzyskać siły przed polowaniem na najlepsze oferty',
      label: 'Strefa Relaksu'
    }
  },
  days: {
    day1: 'Dzień 1',
    day2: 'Dzień 2'
  },
  companyPanel: {
    officesLabel: 'Oddziały',
    phoneLabel: 'T:',
    ourMission: 'Nasza Misja',
    howWeDoIt: 'Jak to robimy?',
    aboutUs: 'O nas?',
    videoGallery: 'Galeria Video',
    articles: 'Artykuły Eksperckie',
    moreButton: 'Więcej',
    dateAndPlaceLabel: 'Data i miejsce',
    prizelabel: 'Nagroda',
    jobBack: 'Wróć do wszyskich ofert'
  },
  partners: {
    supportingPartners: 'Partnerzy Wspierający',
    honoraryPartners: 'Partnerzy Honorowi',
    medialPartners: 'Partnerzy Medialni',
    partners: 'Partnerzy'
  },
  contactUsTitle: 'Kontakt',
  knowledge: {
    title: 'Artykuły eksperckie',
    subTitle: 'Czytaj i rozwijaj się - po prostu zadbaj o swoją zawodową przyszłość',
    tagTitle: 'Co Cię interesuje? Wybierz!',
    latest: 'Najnowsze',
    mostInteresting: 'Najciekawsze',
    recommended: 'Rekomendowane'
  },
  jobOffers: {
    backButton: 'Wróć do wszyskich ofert',
    title: 'Oferty Pracy',
    show: 'Zobacz',
    apply: 'Aplikuj'
  },
  activation: {
    success: 'Email został wysłany!',
    error: 'Nastąpił problem!'
  },
  unsubscribe: {
    success: 'Wypisano!',
    error: 'Nastąpił problem!',
    errorTitle: 'Nie udało się wypisać z listy',
    errorDescription: 'Spróbuj ponownie. Jeśli błąd będzie się powtarzać skontaktuj się z nami.'
  },
  registerSuccess: {
    title: 'Dziękujemy za założenie konta!',
    body: 'Sprawdź swoją skrzynkę e-mail i kliknij w linka potwierdzającego. Jeśli e-mail się nie pojawi w ciągu kilku minut, prosimy o sprawdzenie folderu SPAM, a następnie upewnienie się, że został wpisany poprawny adres e-mail (możesz to zrobić poprzez próbę kolejnej rejestracji wpisując ten sam adres e-mail).',
    greetings: 'Życzymy samych sukcesów!',
    teamCE: '',
    sendEmail: 'Wyślij ponownie e-maila',
    sendEmailSuccess: 'Wysłano!',
    sendEmailError: 'Coś poszło nie tak, spróbuj ponownie.',
    or: 'lub',
    goBack: 'Wróć do rejestracji'
  },
  resetPassword: {
    error: 'Nastąpił problem!',
    title: 'Ustaw nowe hasło',
    passwordLabel: 'Hasło',
    passwordPlaceholder: 'Wpisz Hasło',
    passwordConfirmationLabel: 'Potwierdź Hasło',
    passwordConfirmationPlaceholder: 'Wpisz ponownie Hasło',
    send: 'Wyślij',
    validationErrors: {
      tooShort: 'Hasło jest krótkie!',
      required: 'Pole jest wymagane',
      equal: 'Hasła muszą być takie same'
    }
  },
  forgotPassword: {
    success: 'Wysłano, sprawdź swojego emaila po dalsze instrukcje!',
    userDoesNotExist: 'Użytkownik o takim adresie email nie istnieje!',
    error: 'Nastąpił problem!',
    title: 'Zapomniałem hasła',
    placeholder: 'Wpisz E-mail',
    send: 'Wyślij',
    validationErrors: {
      required: 'Pole jest wymagane',
      email: 'Błędny Email'
    }
  },
  expoRegister: {
    title: 'Szybka Rejestracja',
    firstNameLabel: 'Imię',
    firstNamePlaceholder: 'Wpisz swoje imię...',
    lastNameLabel: 'Nazwisko',
    lastNamePlaceholder: 'Wpisz swoje nazwisko...',
    phoneLabel: 'Telefon',
    phonePlaceholder: 'Przypomnimy Ci o wydarzeniu! Nic więcej.',
    positionLabel: 'Stanowisko',
    positionPlaceholder: 'Wpisz stanowisko, jakie piastujesz / na jakie aplikujesz',
    emailPlaceholder: 'Wpisz Email',
    passwordLabel: 'Hasło',
    passwordPlaceholder: 'Wpisz Hasło',
    checkboxes: {
      all: 'Zaznacz wszystkie zgody',
      accept: 'Akceptuję',
      statuteDescription: 'w celu bezpłatnego korzystania z serwisu careerexpo.pl',
      notifications: 'Chcę otrzymywać przypomnienia o targach, szkoleniach i innych obszarach związanych z Career EXPO',
      shareProfile: 'Chcę udostępniać swój profil Pracodawcom',
      recommendations: 'Chcę otrzymywać informacje o rekomendowanych kandydatach'
    },
    saveLabel: 'Zarejestruj się',
    validationErrors: {
      regulations: 'Musisz zaakceptować regulamin',
      policyPrivacy: 'Musisz zaakceptować polityke prywatności',
      required: 'Pole jest wymagane',
      email: 'Błędny Email',
      tooShort: 'Hasło jest krótkie!'
    }
  },
  controlButtons: {
    edit: 'Anuluj Edytowanie',
    clear: 'Wyczyść formularz',
    reverse: 'Cofnij zmiany'
  },
  registerSuccessMessage: 'Twoje konto zostało aktywowane! Możesz się zalogować.',
  uploadAvatar: {
    buttonSelectLabel: 'Wybierz zdjęcie (PNG/JPG)',
    chooseFileButtonDescription: 'Zaznacz obszar zdjęcia:',
    chooseFileButtonFieldlabel: 'Wybierz plik:',
    chooseFileButtonLabel: 'Wybieram plik',
    chooseFileButtonSendLabel: 'Wyślij zdjęcie',
    chooseFileTitle: 'Dodajesz zdjęcie do swojego CV!',
    croppedImageHeadingText: 'Podgląd:'
  },
  userStepTwo: {
    signUpSuccess: 'Zostałeś zapisany na szkolenie',
    noPlaces: 'Nie ma już miejsc na to szkolenie!',
    unSignUpSuccess: 'Zostałeś wypisany na szkolenie',
    error: 'Następił błąd podczas wypisywania!',
    nextPageError: 'Następił błąd podczas przechodzenia na kolejną stronę!',
    allTrainings: 'Wszystkie szkolenia',
    saved: 'Moje szkolenia',
    showTrainings: 'Zobacz listę dostępnych szkoleń',
    noTrainings: 'Nie zapisałeś się jeszcze na żadne szkolenie!'
  },
  userStepThree: {
    companies: 'Te firmy czekają na Twoją aplikację. Dowiedz się o nich więcej:',
    more: 'Więcej'
  },
  stepsController: {
    back: 'Wstecz',
    homePage: 'Strona główna',
    next: 'Następny',
    skip: 'Pomiń'
  }
}

export default translationsListPL
